import cookie from 'js-cookie'

const currentDomain = location.host.replace(/(.*?)\.(.+?\..+?$)/, '.$2')

/**
 * 获取本地储存
 * @type Function
 * @param {String} key
 */
export function get (key) {
  let response = {}
  let cache = decodeURIComponent(cookie.get(key))

  try {
    if (cache !== 'undefined') {
      response = JSON.parse(cache)
    } else {
      response = ''
    }
  } catch (e) {
    response = cache
  }

  return response
}

/**
 * 设置本地储存
 * @type Function
 * @param {String} key               存储的 key
 * @param {String} value             存储的值
 * @param {Object} option            配置项
 * @param {Number} option.expires    过期天数
 */
export function set (key, value, option) {
  // console.log('<Cookie> set(key, value, option)', key, value, option)
  remove(key)

  if (typeof value !== 'string') {
    value = JSON.stringify(value)
  }

  cookie.set(key, encodeURIComponent(value), { expires: option.expires || 30, domain: currentDomain })
}

export function remove (key) {
  cookie.remove(key, {domain: currentDomain})
}

/**
 * 筛选本地储存
 * @type Function
 * @param {String} key
 * @param {Map}    options
 */
export function filter (key, options = {}) {
  const cookies = cookie.get()

  let response = {}

  if (typeof key === 'string') {
    key = new RegExp('^' + key)
  }

  for (let name in cookies) {
    if (name.match(key)) {
      response[name] = cookie.get(name, options)
    }
  }

  return response
}

/**
 * 根据模糊过滤移除本地储存
 * @param {String}  key     存储的 key 值
 */
export function removeFilter (key) {
  const cookies = cookie.get()

  if (typeof key === 'string') {
    key = new RegExp('^' + key)
  }

  for (let name in cookies) {
    if (name.match(key)) {
      remove(key)
    }
  }
}
